'use client';

// Host storage adapter for @aumonline/org-settings.
// The ONLY place that knows about axios + the backend URL.

import { api } from "./api";

const unwrap = async (p) => (await p).data;

export const createOrgSettingsStorage = () => ({
  getOrg: () => unwrap(api.get("/org")),
  updateOrg: (patch) => unwrap(api.put("/org/profile", patch)),
  uploadLogo: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return unwrap(api.post("/org/logo", fd, { headers: { "Content-Type": "multipart/form-data" } }));
  },
  deleteLogo: () => unwrap(api.delete("/org/logo")),
  // Same-origin GET; the auth cookie is sent automatically by the browser.
  logoUrl: (version) =>
    `${process.env.REACT_APP_BACKEND_URL}/api/org/logo${version ? `?v=${encodeURIComponent(version)}` : ""}`,
});
